import type { ColumnDef } from '../projects/projectsColumns';

export const workOrdersTabColumns: ColumnDef[] = [
  { field: 'WorkOrderId', headerName: 'Work Order ID', sortable: true, width: 140 },
  // 2026-08-06: surface the human-given name (editable on the WO header) —
  // the ID alone told nobody what the work order IS.
  { field: 'WorkOrderName', headerName: 'Name', sortable: true, flex: 1 },
  { field: 'ProjectName', headerName: 'Project', sortable: true, flex: 1 },
  { field: 'ClientName', headerName: 'Client', sortable: true, width: 150 },
  { field: 'SiteName', headerName: 'Site', sortable: true, width: 150 },
  { field: 'WorkOrderStatus', headerName: 'Status', sortable: true, width: 120, type: 'status' },
  // Read-only schedule badge — value built by buildScheduleBadge (helpers).
  // Not sortable: it is a derived composite (plan code/status + booking counts).
  { field: 'Schedule', headerName: 'Schedule', sortable: false, width: 130, type: 'scheduleBadge' },
  // BUG-2026-0183: this count is COUNT(*) of WorkOrderDetail rows = one per
  // test, not samples. Header relabeled "Tests" to match the actual value.
  { field: 'SampleCount', headerName: 'Tests', sortable: true, width: 90 },
  // Renamed "Tests" -> "Test Types" so it doesn't collide with the (now)
  // "Tests" count column above; this column lists the distinct test-type names.
  { field: 'TestTypes', headerName: 'Test Types', sortable: false, flex: 1 },
  { field: 'LabLocation', headerName: 'Lab', sortable: true, width: 110 },
  // Origin quote (via the converted quote's ScheduleTasks) — blank for WOs
  // that never came from a quote.
  { field: 'FromQuoteNumber', headerName: 'From Quote', sortable: false, width: 120 },
  { field: 'WorkOrderStartDate', headerName: 'Start Date', sortable: true, width: 120 },
  { field: 'Progress', headerName: 'Completed', sortable: false, width: 100 },
  { field: 'Remarks', headerName: 'Remarks', sortable: false, flex: 1 },
  { field: 'sysCreateUser', headerName: 'Created By', sortable: true, width: 130 },
  { field: 'sysLastModifiedDate', headerName: 'Last Modified', sortable: true, width: 150 },
];
